import React, { useState } from 'react';
import type { Product } from '../../types/product';
export function ProductGallery({
  product
}: {
  product: Product;
}) {
  const [active, setActive] = useState(0);
  return <div className="flex flex-col-reverse gap-3 lg:flex-row lg:gap-4" data-id="element-321" data-mp="28g09uf362e7h">
      {product.gallery.length > 1 && <ul className="flex gap-3 lg:flex-col" aria-label="Afbeeldingen" data-id="element-322" data-mp="2cgk3v9sg11pe">
          {product.gallery.map((src, i) => <li key={src} data-id="element-323" data-mp="1ygsvbokp4dis" data-mpi={i}>
              <button type="button" onClick={() => setActive(i)} aria-label={`Afbeelding ${i + 1}`} aria-current={active === i} className={`block overflow-hidden rounded-xl border-2 transition-colors duration-150 ${active === i ? 'border-ink' : 'border-transparent hover:border-line'}`} data-id="element-324" data-mp="1yjng5h7mg0cq">
                <img src={src} alt="" className="h-16 w-16 bg-surface object-cover lg:h-20 lg:w-20" data-id="element-325" data-mp="3nwig1mix43uu" />
              </button>
            </li>)}
        </ul>}
      <div className="flex-1 overflow-hidden rounded-3xl bg-surface" data-id="element-326" data-mp="16skjskdp54zx">
        <img src={product.gallery[active]} alt={product.name} className="aspect-square w-full object-cover object-[50%_30%]" data-id="element-327" data-mp="11u94hu4mu2ab" />
      </div>
    </div>;
}